import { DropdownTrigger, DropdownItem, styled, theme } from '@nilohealth/core-ui'
import * as Dropdown from '@radix-ui/react-dropdown-menu'

export const NavbarContainer = styled('div', {
  position: 'fixed',
  backgroundColor: '$neutralHighPure',
  display: 'flex',
  justifyContent: 'center',
  width: '100vw',
  height: '$large',
  borderBottom: '1px solid $neutralHighMedium',
  zIndex: '$zIndex200',
  '@xs': { height: '$medium', },
  '@sm': { height: '$medium', },
  '@md': { height: '$medium', },
  '@lg': { height: '$large', },
  '@xl': { height: '$large', },
})

export const NavbarIconWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  variants: { primary: { true: { svg: { color: '$primaryMedium' } } } },
  '@sm': {
    svg: {
      size: '$xxxsmall',
      minWidth: '$xxxsmall',
      maxHeight: '$xxxsmall',
    },
  },
  '@md': {
    svg: {
      size: '$xxxsmall',
      minWidth: '$xxxsmall',
      maxHeight: '$xxxsmall',
    },
  },
  '@lg': {
    svg: {
      size: '$xxsmall',
      minWidth: '$xxsmall',
      maxHeight: '$xxsmall',
    },
  },
  '@xl': {
    svg: {
      size: '$xxsmall',
      minWidth: '$xxsmall',
      maxHeight: '$xxsmall',
    },
  },
})

export const NavbarDivider = styled('div', {
  display: 'flex',
  width: '1px',
  height: '$xxsmall',
  border: '1px solid $primaryPure',
})

export const NavbarLogo = styled('div', {
  display: 'flex',
  objectFit: 'contain',
  '@sm': {
    height: '$xxxsmall',
    maxWidth: '$xxxlarge',
  },
  '@md': {
    height: '$xxxsmall',
    maxWidth: '$xxxlarge',
  },
  '@lg': {
    height: '$xxsmall',
    maxWidth: '$xxlarge',
  },
  '@xl': {
    height: '$xxsmall',
    maxWidth: '$xxlarge',
  },
})

export const NavbarListContainer = styled('nav', {
  display: 'flex',
  alignItems: 'center',
  columnGap: '$nano',
})

export const NavbarListItem = styled('a', {
  display: 'flex',
  alignItems: 'center',
  padding: '$quarck $nano',
  borderRadius: '$small',
  textDecoration: 'none',
  color: '$neutralLowDark',
  '&:focus, &:focus-within': {
    outline: 0,
    boxShadow: '0 0 0 $borderWidths$thick $colors$primaryMedium',
  },
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '$neutralHighLight',
  },
})

export const NavbarMenuTrigger = styled(DropdownTrigger, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 0,
  backgroundColor: 'transparent',
  borderRadius: '$circular',
  outline: 'none',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: `${theme.colors.primaryMedium.value}${theme.opacitiesHex.light.value}`,
  },
  '&:focus, &:active': {
    outline: 0,
    boxShadow: '0 0 0 $borderWidths$thick $colors$primaryMedium',
  },
  size: '$xxsmall',
  maxWidth: '$xxsmall',
  svg: {
    size: '$micro',
    minWidth: '$micro',
    maxWidth: '$micro',
  },
  variants: {
    active: {
      true: {
        cursor: 'pointer',
        backgroundColor: `${theme.colors.primaryMedium.value}${theme.opacitiesHex.light.value}`,
        outline: 0,
      },
    },
  },
})

export const NavbarListMenuPortal = styled(Dropdown.Portal, {
  zIndex: '$dialog',
  position: 'fixed',
  left: 0,
  top: '$medium',
  width: '100vw',
  transform: 'none !important',
})

export const NavbarMenuItem = styled(DropdownItem, {
  borderRadius: '$medium',
  border: '1px solid $neutralHighPure',
  padding: 0,
  '&:hover, &:focus, &:active': {
    cursor: 'pointer',
    backgroundColor: `${theme.colors.primaryMedium.value}${theme.opacitiesHex.light.value}`,
    border: '1px solid $primaryMedium',
  },
  a: { textDecoration: 'none', },
})
